<template>
  <div class="batch-modal">
    <Modal
      v-model="showModal"
      :title="`批量设置(已选商品课程${selectRows.length})`"
      :footer-hide="true"
      :closable="false"
      :width="690"
      :mask-closable="false"
    >
      <div class="batch-modal-main">
        <p class="title">
          <Icon type="md-alert" size="18" style="margin: 0 10px"></Icon
          >每次只能批量修改一项
        </p>
        <div class="content">
          <div class="left">
            <p
              v-for="(item, index) in tabs"
              :key="item.id"
              :class="{ active: tabIndex === index }"
              @click="handleLeftClick(index)"
            >
              {{ item.name }}
            </p>
          </div>
          <div class="right">
            <Form ref="formInline" :model="formInline" :label-width="100">
              <FormItem v-show="tabIndex === 0" label="每班上限人数">
                <InputNumber
                  v-model="formInline.maxNum"
                  :min="1"
                  placeholder="请输入"
                  :disabled="smartPartitionType == 2"
                ></InputNumber>
              </FormItem>
              <p v-show="tabIndex === 0 && smartPartitionType == 2">
                （分班模式为按学生所在班级分班时，无需填写每班上限人数）
              </p>
              <FormItem v-show="tabIndex === 1" label="周循环">
                <InputNumber
                  v-model="formInline['weekCycleNum']"
                  :min="1"
                  disabled
                  placeholder="请输入"
                ></InputNumber>
              </FormItem>
              <FormItem v-show="tabIndex === 2" label="开课日期">
                <DatePicker
                  :ref="`datePicker`"
                  v-model="dateValue"
                  type="date"
                  placeholder="请选择"
                  style="width: 200px"
                  class="date-pick"
                  :transfer="true"
                  :options="datePickeroptions"
                  @on-change="handleDatePickChange"
                  @on-open-change="onDatePickOpenChange"
                ></DatePicker>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
      <div
        class="price-btn-box"
        style="display: flex; justify-content: flex-end"
      >
        <Button style="margin-right: 32px" @click="handleCancel">取消</Button>
        <Button type="primary" @click="checkForm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: true
    },
    smartPartitionType: {
      type: [String, Number],
      default: 2
    },
    selectRows: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      tabs: [{
        name: '每班上限人数',
        id: 1
      }, {
        name: '周循环',
        id: 2
      }, {
        name: '开课日期',
        id: 3
      }],
      tabIndex: 0,
      formInline: {
        maxNum: 1,
        weekCycleNum: 1,
        startTime: ''
      },
      dateValue: ''
    };
  },
  computed: {
    weekDates() {
      let weeks = [];

      this.selectRows.forEach(item => {
        try {
          const ws = item.classTimeList ? item.classTimeList.map(item_1 => { return item_1.weekDate; }) : [];
          weeks = [...weeks, ...ws];
        } catch (err) {

        }
      });
      return [...new Set(weeks)];
    },
    datePickeroptions(index) {
      const _this = this;
      return {
        disabledDate(date) {
          const weekDate = _this.getDateWeekDate(date);

          return !_this.weekDates.includes(weekDate);
        }
      };
    }
  },
  watch: {
    show(newVal) {
      this.showModal = newVal;
      this.showModal && this.init();
    }
  },
  created() {

  },
  methods: {
    //
    init() {
      this.formInline = {
        maxNum: 1,
        weekCycleNum: 1,
        startTime: ''
      };
      this.dateValue = '';
      console.log(this.dateValue);
      this.tabIndex = 0;
    },
    // 获取某个日期是周几（其中周日在这边是7） date是newdate格式化之后的
    getDateWeekDate(date) {
      let weekDate = date.getDay();
      weekDate === 0 ? weekDate = 7 : '';
      return weekDate;
    },
    // 设置 日期选中器 禁止选项

    handleOk() {
      this.$Message.success('设置成功');
      this.$emit('on-Finish', {
        type: 'ok',
        index: this.tabIndex,
        form: this.formInline
      });
    },
    handleCancel() {
      this.$emit('on-Finish', {
        type: 'cancel'
      });
    },
    // 检查表单
    checkForm() {
      switch (Number(this.tabIndex)) {
        case 0:
          if (!this.formInline.maxNum) {
            return this.$Message.warning('每班上限人数不能为空，且需>=1');
          }
          break;
        case 1:
          if (!this.formInline.weekCycleNum) {
            return this.$Message.warning('周循环不可为空，且需>=1');
          }
          break;
        case 2:
          if (!this.formInline.startTime) {
            return this.$Message.warning('请填写开课日期');
          }
          break;
      }
      this.handleOk();
    },
    handleLeftClick(index) {
      this.tabIndex = index;
    }, // 日期选择改变
    handleDatePickChange(date, v) {
      console.log(date);
      this.formInline['startTime'] = date;
    },
    // 日期组件打开时
    onDatePickOpenChange(status) {
      if (status) {
        // this.dateValue = this.courseData[this.selectIndex]['startTime'];
      }
    }
  }
};
</script>

<style lang="scss" scoped >
.batch-modal {
  &-main {
    margin-bottom: 16px;
    .title {
      background: #fff8ea;
      border-radius: 2px;
      border: 1px solid #ffc68b;
      font-size: 14px;
      color: #f3a000;
      line-height: 30px;
      height: 30px;
      margin-bottom: 16px;
    }
    .content {
      display: flex;
      .left {
        width: 160px;
        height: 214px;
        background: #f7f7f9;
        border-radius: 2px;
        margin-right: 16px;
        p {
          padding: 8px 10px;
          cursor: pointer;
        }

        .active {
          color: #488ffa;
          font-weight: bold;
          position: relative;
          &:before {
            display: inline-block;
            content: '';
            width: 2px;
            height: 14px;
            position: absolute;
            left: 0px;
            top: 50%;
            background-color: #488ffa;
            transform: translateY(-50%);
          }
        }
      }
      .right {
        flex: 1;
      }
    }
  }
}
</style>
